<template>
  <div class="circle">
    <div class="ri-font-24">
      {{ emojiWithDefault }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import * as _ from 'lodash';
import { computed } from 'vue';
import { availableColors, availableEmojis } from '../../consts/challenge';

interface Props {
    emoji?: string;
    color?: string;
    circleBorder?: boolean;
}

const props = withDefaults(
  defineProps<Props>(),
  { circleBorder: false },
);
const emojiWithDefault = computed(() => props.emoji ?? _.sample(availableEmojis));
const colorWithDefault = computed(() => props.color ?? _.sample(availableColors));
</script>

<style
    lang="scss"
    scoped
>
@import 'base-ui-vue3/src/scss/riseup-colors';

  .circle {
    background-color: v-bind('`${colorWithDefault}`');
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

</style>
